import { render, staticRenderFns } from "./baseIndex.vue?vue&type=template&id=96b7eb38&"
import script from "./baseIndex.vue?vue&type=script&lang=js&"
export * from "./baseIndex.vue?vue&type=script&lang=js&"
import style0 from "./baseIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports